const colors = {
  primary: "#ffac3c",
  secondary: "#111a20",
  secondaryVariant1: "#243341",
  secondaryVariant2: "#162530",
  textLight: "#ffffff",
  textDark: "#81929e",
  error: "#f50101",
  success: "#2ecc71",
};

export default colors;
